import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmergencyLocationsSearchResults } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class EmergencyLocationSearchResource {
  private http = inject(HttpClient);

  searchLocations(tenantId: string, query: string): Observable<EmergencyLocationsSearchResults> {
    return this.http.get<EmergencyLocationsSearchResults>(
      `/services/microsoft/emergency-calling-management/tenants/${tenantId}/emergency-locations/search?name=${encodeURIComponent(query)}`,
    );
  }
}
